import { Injectable } from '@angular/core';
import { ApiparserService } from '../apiparser/apiparser.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  constructor(private parser: ApiparserService) { }

  create(params){
    return this.parser.hit('/rest/category/new', 'post', {params: params});
  }

  delete(params){
    return this.parser.hit('/rest/category','delete',{params:params});
  }

  put(id: any, params: object) {
    return this.parser.hit('/rest/category/' + id, 'put', params);
  }
}
